import {RouteConfig} from 'vue-router';
import PrintView from '@/views/main/print/Print.vue';
import MainView from '@/views/main/Main.vue';


export const MainRoutes: Array<RouteConfig | any> = [
  {
    path: '/main',
    name: 'main',
    component: MainView,
    children: [
      {path: 'print', name: 'print', component: PrintView}
    ],
  },
];
